import React from 'react';
import Label from '../../atoms/Label';
import { FiX } from 'react-icons/fi';

const ExitConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="exit-confirmation-modal">
        
        <div className="exit-modal-content">
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}> 
          <h2>Do you want to Exit these Practice test ?</h2>
          <div className="modal-close-icon" onClick={onClose}>X</div>
          </div>
          <p>
            If you exit now, your test will end, and your score will be calculated. You will not be
            able to return to the test. Are you sure you want to end your test and exit?
          </p>
          <div className="exit-modal-actions">
            <button className="continue-btn" onClick={onClose}>
              Continue Practice Test
            </button>
            <button className="end-score-btn" onClick={onConfirm}>
              End and Score
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitConfirmationModal; 